import React, {Fragment} from 'react';

import Footer from './Footer';

const Layout = ({ children }) => {

	return (
		<Fragment>

			{children}

			<Footer />

		</Fragment>
	);
};

export default Layout;